import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useCallback,
  useRef,
} from 'react'
import { useParams } from 'react-router-dom'
import QuestTypeformEditor from './QuestTypeformEditor'
import { EnrollmentFormPreviewModal } from '@abroad/components'

const QuestEnrollmentTypeform = forwardRef(
  ({ questDetail, onQuestionsChange }, ref) => {
    const [previewQuestions, setPreviewQuestions] = useState([])
    const [showPreview, setShowPreview] = useState(false)
    const editorRef = useRef(null)
    const { questId } = useParams()

    useImperativeHandle(ref, () => ({
      openPreview: () => setShowPreview(true),
      openCopyFrom: () => {
        const openCopyFrom = editorRef.current && editorRef.current.openCopyFrom
        if (typeof openCopyFrom === 'function') {
          openCopyFrom()
        }
      },
    }))

    const handleQuestionsChange = useCallback(
      (questions) => {
        const list = Array.isArray(questions) ? questions : []
        setPreviewQuestions((prev) => (prev === list ? prev : list))
        if (typeof onQuestionsChange === 'function') {
          onQuestionsChange(list)
        }
      },
      [onQuestionsChange],
    )

    return (
      <div className='quest-enrollment-typeform'>
        <QuestTypeformEditor
          ref={editorRef}
          onQuestionsChange={handleQuestionsChange}
          hidePreviewButton
        />

        <EnrollmentFormPreviewModal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          questId={questId}
          questTitle={questDetail?.title}
          questions={previewQuestions}
          isLoading={false}
        />
      </div>
    )
  },
)

QuestEnrollmentTypeform.displayName = 'QuestEnrollmentTypeform'

export default QuestEnrollmentTypeform
